var render, staticRenderFns
import script from "./ErrorPageComponent.vue?vue&type=script&lang=js&"
export * from "./ErrorPageComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8cb16e4",
  null
  
)

export default component.exports